import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import { isFunction } from 'lodash';
import classnames from 'classnames';

import { CoreSelectBox } from 'components/core/library/selectBox';
import { Text } from 'components/core/Typography';
import { ChevronDown } from 'components/svg';

import './selectBox.scss';

const enhance = compose(
	withState('value', 'setValue', (props) => props.value),
	withState('hasError', 'setHasError', false),
	withHandlers({
		handleChange: (props) => (evt) => {
			const { value } = evt.target;
			const newHasError =
				isFunction(props.validator) && value.length
					? props.validator(value)
					: false;
			props.setValue(value);
			props.setHasError(newHasError);

			if (isFunction(props.onChange)) {
				props.onChange(evt);
			}
		},
	}),
	lifecycle({
		componentWillReceiveProps(nextProps) {
			if (this.props.value !== nextProps.value) {
				this.props.setValue(nextProps.value);
			}
		},
	}),
);

const SelectBox = ({
	id,
	disabled,
	label,
	large,
	className,
	reduxFormError,
	errorMessage,
	options,
	value,
	hasError,
	handleChange,

	isModal,
}) => {
	return (
		<label
			htmlFor={id}
			className={classnames('ph-label', 'select-box-label', {
				'label-error-datepicker':
					(hasError || reduxFormError) && isModal,
			})}
		>
			<Text
				size="small"
				className="selected-value"
			>
				{options.find((o) => o.value === value)?.display}
			</Text>
			<CoreSelectBox
				className={classnames(className, {
					'select-input-large': large,
					'select-input-standard': !large,
					disabled,
					error: hasError || reduxFormError,
				})}
				disabled={disabled}
				id={id}
				label={label}
				onChange={handleChange}
				value={value}
				key="core-selectbox"
				options={options}
			/>
			<div className="dropdown-icon">
				<ChevronDown />
			</div>
			<div
				className={classnames(
					{ 'margin-error-datepicker': isModal },
					'input-error',
				)}
				key="input-error"
			>
				{hasError || reduxFormError ? errorMessage : null}
			</div>
		</label>
	);
};

SelectBox.propTypes = {
	className: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			display: PropTypes.any,
		}),
	),
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	large: PropTypes.bool,
	disabled: PropTypes.bool,
	label: PropTypes.node.isRequired,
	id: PropTypes.string.isRequired,
	errorMessage: PropTypes.node,
	hasError: PropTypes.bool,
	handleChange: PropTypes.func,
	reduxFormError: PropTypes.bool,
	isModal: PropTypes.bool,
};

SelectBox.defaultProps = {
	options: [],
};

export default enhance(SelectBox);
